window.addEventListener('DOMContentLoaded', function() {
  const secondaryButtons = document.querySelectorAll('.btn-secondary');

  secondaryButtons.forEach(function(button) {
    for (let spanIndex = 0; spanIndex < 4; spanIndex++) {
      let createSpan = document.createElement('span');
      createSpan.classList.add('btn-secondary-span-' + spanIndex); // Use string concatenation
      createSpan.classList.add('animate-span'); // Use string concatenation
      button.prepend(createSpan);
    }
  });
});